import { render, staticRenderFns } from "./Inizia.vue?vue&type=template&id=6aa0fce9&scoped=true&"
import script from "./Inizia.vue?vue&type=script&lang=js&"
export * from "./Inizia.vue?vue&type=script&lang=js&"
import style0 from "./Inizia.vue?vue&type=style&index=0&id=6aa0fce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0fce9",
  null
  
)

export default component.exports